module.exports = __webpack_public_path__ + "img/pr-3.b29ddf14.png";